import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { Hero } from "@/components/sections/Hero";
import { About } from "@/components/sections/About";
import { Portfolio } from "@/components/sections/Portfolio";
import { Exits } from "@/components/sections/Exits";
import { Skills } from "@/components/sections/Skills";
import { Contact } from "@/components/sections/Contact";
import { scrollToId } from "@/lib/scroll";

export default function Home() {
  const { state } = useLocation();
  useEffect(() => {
    if (!state?.scrollTo) return undefined;
    const t = setTimeout(() => scrollToId(state.scrollTo), 150);
    return () => clearTimeout(t);
  }, [state]);

  return (
    <main>
      <Hero />
      <About />
      <Portfolio />
      <Exits />
      <Skills />
      <Contact />
    </main>
  );
}
